export const isStereoPannerNode = (audioNode) => {
    return 'pan' in audioNode;
};
//# sourceMappingURL=stereo-panner-node.js.map